import instance from "./axios";

export const loadApi = () => instance.get("dispositivos");
export const saveDispositivos = (newDispositivos) =>
  instance.post("dispositivo/disp/", newDispositivos);
export const updateDispositivos = (disp) => {
  return instance.put("dispositivo/" + disp.id, disp);
};
export const logDispositivosId = (id) => instance.get("dispositivo/disp/log/userid/" + id);
export const deleteDispositivos = (disp) => instance.post("dispositivo/disp/log", disp);
export const loadDispositivosByUid = (uid) => instance.get("dispositivo/" + uid);
export const loadDispositivosByid = (id) => instance.get("dispositivo/disp/id/" + id);
export const saveUser = (NewUser) => instance.post("user", NewUser);
export const loadUserByUid = (uid) => instance.get("user/uid/" + uid);
export const updateUser = (user) => instance.put("user/" + user.id, user);
export const updateSituacao = (situacao) =>
  instance.put("dispositivos/situacao/" + situacao.id, situacao);
export const getSituacao = () => instance.get("dispositivos/situacao");

export const apiBOinterativo = (bo) => instance.post("cad/sispol/bo/validate", bo);
export const loadAux = () => instance.get("aux/table");

const apis = {
  loadApi,
  saveDispositivos,
  updateDispositivos,
  deleteDispositivos,
  saveUser,
  loadUserByUid,
  updateUser,
  loadDispositivosByUid,
  loadDispositivosByid,
  logDispositivosId,
  loadAux,
  updateSituacao,
  getSituacao,
  apiBOinterativo,
};

export default apis;



// WEBPACK FOOTER //
// ./src/services/Api.js